import React, { useState, useContext } from "react";

const ReloadContext = React.createContext();
const UpdateReloadContext = React.createContext();

export function useReloadContext() {
  return useContext(ReloadContext);
}
export function useUpdateReloadContext(){
  return useContext(UpdateReloadContext);
}

const ThemeContext = ({ children }) => {
  const [reload, shouldReload] = useState(false);
  const setShouldReload = () => {
    shouldReload(!reload);
  };
  return (
    <ReloadContext.Provider value={{ reload, shouldReload }}>
      <UpdateReloadContext.Provider value={setShouldReload}>
        {children}
      </UpdateReloadContext.Provider>
    </ReloadContext.Provider>
  );
};
export default ThemeContext;
